import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
const Loading = ({ loading, children , height , fallback }) => {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 32,
      }}
      spin
    />
  );

  return (
    <>{loading ? <Spin style={fallback ? { height:"100vh" , display : "flex", justifyContent : "center", alignItems : "center" } : { maxHeight :  height ? `${height}%` : "80vh" , width:"100%", zIndex: "" }} indicator={antIcon}>{children}</Spin> : children}</>
  );
};

export default Loading;
